import lodash from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    TableContainer,
} from '@material-ui/core';
import { Tooltip, Icon } from 'antd';
import Moment from 'react-moment';
import TableLoader from '../../../../../components/table/TableLoader';
import TableNoData from '../../../../../components/table/TableNoData';
import { checkLeadTypeUpdate, isBikeManagementUpdate } from '../../../utils/leadType';

const tooltipLeadType = 'Manual revaluation required';

const tableCols = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'Date', align: 'center' },
    { content: 'Author', align: 'center' },
    { content: 'Action', align: 'center' },
];
class LeadHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rpp: 10,
            page: 0,
        };
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rpp: event.target.value });
    };

    render() {
        const { page, rpp } = this.state;
        const { data, isLoading } = this.props;
        const dataFrom = page * rpp;
        const dataTo = dataFrom + rpp;
        const cuttedData = data.length && data.slice(dataFrom, dataTo);

        return (
            <Fragment>
                <TableContainer>
                    <Table size="small" aria-label="lead history table">
                        <TableHead>
                            <TableRow>
                                {
                                    tableCols.map((title) => (
                                        <TableCell
                                            key={title}
                                            align={title.align}
                                            style={{
                                                width: [title.width],
                                            }}
                                        >
                                            {title.content}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                !isLoading && lodash.isEmpty(data) && <TableNoData colSpan={tableCols.length} />
                            }
                            {
                                isLoading
                                    ? <TableLoader colSpan={tableCols.length} />
                                    : cuttedData && cuttedData.map((item, index) => {
                                        const firstName = lodash.get(item, 'created_by.person.first_name');
                                        const lastName = lodash.get(item, 'created_by.person.last_name');
                                        const fullName = `${firstName} ${lastName}`;
                                        const { action } = item;
                                        const isLeadTypeUpdate = isBikeManagementUpdate(action) && checkLeadTypeUpdate(action);

                                        return (
                                            <TableRow key={item._id || item.created_date}>
                                                <TableCell align={tableCols[0].align}>
                                                    <span>{dataFrom + index + 1}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[1].align}>
                                                    <span><Moment format="D MMM YYYY | HH:mm">{item.created_date}</Moment></span>
                                                </TableCell>
                                                <TableCell align={tableCols[2].align}>
                                                    <span>{fullName}</span>
                                                </TableCell>
                                                <TableCell align="left">
                                                    <span>
                                                        {isLeadTypeUpdate && <Tooltip title={tooltipLeadType}><Icon type="warning" style={{ color: 'red', fontSize: 14, marginRight: 4 }} /></Tooltip>}
                                                        {action}
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    count={data.length}
                    rowsPerPage={rpp}
                    page={!data.length ? 0 : page}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({ ...state.Leads.Lead_profile.leadHistory });

export default connect(mapStateToProps)(LeadHistory);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_history/LeadHistory.js